import React, { Component } from 'react';

import money, { format } from '../../../lib/money';
import Membership from '../../../lib/membership';

class SummaryShareShort extends Component {
  constructor(props) {
    super(props);
    this.onCommit = this.props.onCommit.bind(this);
    this.onWithdraw = this.props.onWithdraw.bind(this);
  }

  get allowedShareAmount() { return money(this.props.membership.allowedShareAmount); }

  get shareAmount() { return money(this.props.membership.shareAmount); }

  get withdrawButton() {
    if (Membership.getPaidContributions(this.props.membership.contributions).length) return;
    return (
      <p className="small-print">
        <button type="button" className="btn-link" onClick={this.onWithdraw}>Withdraw</button>
      </p>
    );
  }

  render() {
    const { disabled } = this.props;

    return (
      <div className="summary-share-committed yourshare-block gray">
        <div className="yourshare-box pt-4">
          <div className="contribute text-center coral-error">
            Your current share is short
            <h2>{format(this.allowedShareAmount)}</h2>
            <div className="mb-2 small-print">
              The new share is {format(this.shareAmount)}
            </div>
            <div className="contribute text-center">
              <p>
                <button
                  type="button"
                  onClick={this.onCommit}
                  className="btn btn-primary btn-block"
                  disabled={disabled}
                >
                  Accept cost increase
                </button>
              </p>
              {this.withdrawButton}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SummaryShareShort.defaultProps = {
  onCommit: () => { },
  onWithdraw: () => { },
};

export default SummaryShareShort;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/summary-share.short.js